import Vue from 'vue'
import axios from 'axios'
window.axios = axios

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import vConsole from "vconsole"
// new vConsole()

import { Popover,Dropdown,
  DropdownMenu,
  DropdownItem,Switch} from 'element-ui';
Vue.use(Popover);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Switch);

import 'babel-polyfill'
import 'nprogress/nprogress.css'
import 'swiper/css/swiper.min.css'
import './assets/styles/normalize.css'
import './assets/styles/base.scss'
import domain from '~/ui-domain';
console.log('%c [ domain ]-14', 'font-size:13px; background:pink; color:#bf2c9f;', domain)
window.domain = domain;
import './assets/styles/iconfont/iconfont.css'
import * as EnComponents from './components'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueLazyLoad from 'vue-lazyload'
import VueMeta from 'vue-meta'
import VueCropper from 'vue-cropper'
import VueViewer from 'v-viewer'

import App from './App'
import i18n from './lang'
import router from './router'
import './router/router-hook'
import store from './store'
import './utils/vue-layer'
import './utils/vue-element'

import * as filters from './utils/filters'
import mixin from './utils/mixin'
Vue.use(VueViewer)
Vue.use(VueAwesomeSwiper)
Vue.use(VueLazyLoad)
Vue.use(VueMeta)
Vue.use(VueCropper)
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Object.keys(EnComponents).forEach(key => {
  Vue.component(EnComponents[key].name, EnComponents[key])
})



Vue.mixin(mixin)

Vue.config.productionTip = false

const newV = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})
export default newV



// WEBPACK FOOTER //
// ./src/main.js